<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.3809 22.6737L15.0005 27.6851L2.62012 22.6737V7.63965L15.0005 2.6283L27.3809 7.63965V22.6737Z"
      fill="#8ED5E3"
    />
    <path
      d="M15.0006 13.2776C14.9263 13.2776 14.8437 13.2609 14.7695 13.2358L2.38905 8.22446C2.07542 8.09918 1.9186 7.73168 2.0424 7.41429C2.16621 7.09691 2.52936 6.93821 2.843 7.0635L14.9923 11.983L27.1416 7.0635C27.4635 6.93821 27.8184 7.08855 27.9422 7.41429C28.066 7.73168 27.9175 8.09918 27.5956 8.22446L15.2152 13.2358C15.1409 13.2692 15.0666 13.2776 14.9841 13.2776H15.0006Z"
      fill="#011837"
    />
    <path
      d="M15.0004 28.3117C14.9261 28.3117 14.8436 28.295 14.7693 28.2699L2.3889 23.2586C2.14954 23.1667 2.00098 22.9328 2.00098 22.6739V7.63986C2.00098 7.38094 2.1578 7.15543 2.3889 7.0552L14.7693 2.04385C14.9179 1.98538 15.0829 1.98538 15.2315 2.04385L27.6119 7.0552C27.8513 7.14708 27.9998 7.38094 27.9998 7.63986V22.6739C27.9998 22.9328 27.843 23.1583 27.6119 23.2586L15.2315 28.2699C15.1572 28.3033 15.0829 28.3117 15.0004 28.3117ZM3.23902 22.248L15.0004 27.0087L26.7618 22.248V8.06582L15.0004 3.30504L3.23902 8.06582V22.248Z"
      fill="#011837"
    />
    <path
      d="M15.0009 28.3118C14.6625 28.3118 14.3818 28.0278 14.3818 27.6854V12.6513C14.3818 12.3089 14.6625 12.0249 15.0009 12.0249C15.3393 12.0249 15.6199 12.3089 15.6199 12.6513V27.6854C15.6199 28.0278 15.3393 28.3118 15.0009 28.3118Z"
      fill="#011837"
    />
  </svg>
</template>
